import { api, PartipostApiResponse } from './'

export enum UploadType {
    BRAND = process.env.REACT_APP_CLOUDINARY_PRESET_NAME_BRAND as any,
    CAMPAIGN = process.env.REACT_APP_CLOUDINARY_PRESET_NAME_CAMPAIGN as any,
    BANNER = process.env.REACT_APP_CLOUDINARY_PRESET_NAME_BANNER as any,
    BILLING = process.env.REACT_APP_CLOUDINARY_PRESET_NAME_BILLING as any,
}

export interface FileSignatureRequest {
    preset_type: UploadType
    quantity?: number
}

export interface FileSignatureResponse {
    timestamp: number
    signature: string
    public_id: string
    upload_preset: UploadType
    tags: string[]
}

export const getFileSignature = (payload: FileSignatureRequest) => {
    return api.post<PartipostApiResponse<FileSignatureResponse>>('file-signatures/', payload)
}
